import { fromUnixTime, subDays, set, isBefore } from 'date-fns'
import { useGqlExamTestsQuery } from 'generated/graphql'

type TUseGetIsPreReservedProps = {
  companyId: string
  termId: string
}

type TUseGetIsPreReservedFn = (params: TUseGetIsPreReservedProps) => boolean

/**
 * 사전 예약 가능 여부를 확인하는 커스텀 훅
 *
 * 이 훅은 시험 응시날짜 리스트를 가져온 후,
 * 현재 시간이 사전 예약 마감 시간(가장 이른 시험 전날 23:59) 이전인지 확인합니다.
 *
 * @param {TUseGetIsPreReservedProps} params - 훅 파라미터
 * @param {string} params.companyId - 기업 ID
 * @param {string} params.termId - term ID
 * @returns {boolean} - 사전 예약이 가능하면 true, 불가능하면 false를 반환합니다.
 */
const useGetIsPreReserved: TUseGetIsPreReservedFn = ({ companyId, termId }) => {
  const { data: listData, loading } = useGqlExamTestsQuery({
    variables: {
      input: {
        companyId,
        termId,
      },
    },
    nextFetchPolicy: 'cache-first',
  })

  const sortedExamTests = listData?.examTests
    ? [...listData.examTests].sort((a, b) => a.date - b.date)
    : []

  const earliestExamTimestamp = sortedExamTests[0]?.date ?? 0
  const earliestExamDate = fromUnixTime(earliestExamTimestamp / 1000)
  const dayBeforeExam = subDays(earliestExamDate, 1)

  const preReservationDeadline = set(dayBeforeExam, {
    hours: 23,
    minutes: 59,
    seconds: 0,
    milliseconds: 0,
  })

  const currentDate = new Date()

  const isPreReservation = loading
    ? true
    : isBefore(currentDate, preReservationDeadline)

  return isPreReservation
}

export default useGetIsPreReserved
